module.exports = __webpack_public_path__ + "img/vocus-logo.aa637683.png";